<div #content class="content {{ class }}">
    <ng-content></ng-content>
</div>
